export default "__VITE_ASSET__9b990d6c__"